import { render, staticRenderFns } from "./KnowledgeManageSettingsGroupRow.vue?vue&type=template&id=26681ec8&scoped=true&"
import script from "./KnowledgeManageSettingsGroupRow.vue?vue&type=script&lang=js&"
export * from "./KnowledgeManageSettingsGroupRow.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeManageSettingsGroupRow.vue?vue&type=style&index=0&id=26681ec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26681ec8",
  null
  
)

export default component.exports